export var theme = {
    wrapper: {
        width: '80%',
        margin: 'auto',
        '& > div': {
            display: 'flex',
            alignItems: 'center',
        },
        '& > div:last-child': {
            flexDirection: 'column',
            justifyContent: 'center',
            rowGap: '1rem',
            width: '100%',
            columnGap: '10px',
        },
        '& > div:last-child button': {
            margin: 0,
            marginLeft: '15px',
        },
    },
};
